let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/radio");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");
let FormMixin = require("react-loose-forms");
let FormUtils = require("../../../../../utils/FormUtils");
let FormButtons = require("react-loose-forms.bootstrap3/layouts/FormButtons");
let normalizeUsername = require("../../../../../utils/normalizeUsername");
let getUsernameOptions = require("./getUsernameOptions");
let ezHorizontalFields = require("react-loose-forms.bootstrap3/layouts/ezHorizontalFields");
let HorizontalFieldSpot = require("react-loose-forms.bootstrap3/layouts/HorizontalFieldSpot");

let DaForm = dd.createClass({
	mixins: [FormMixin],
	buildSchema(){
		let {event} = this.props;
		return  {
			"status": {
				type: "select",
				label: "Completed",
				placeholder: "no change",
				options: {
					"complete": "set complete",
					"incomplete": "set incomplete"
				},
				validate: FormUtils.v.optional
			},
			statusdate: {
				type: "date",
				label: "Due Date",
				validate: FormUtils.v.optional
			},
			assignedto: {
				type: "select",
				options: getUsernameOptions(event),
				placeholder: "--",
				validate: FormUtils.v.optional
			}
		};
	},
	render(){
		let {onClose, onDeleteItems} = this.props;
		return dd.form({onSubmit: this.Form_onSubmit},
			ezHorizontalFields(this),
			dd.div({className: "clearfix"}),
			dd.div({style: {marginTop: "1em"}},
				HorizontalFieldSpot(null,
					FormButtons({
						right_align: true,
						delete_btn_text: "Delete",
						onDelete: onDeleteItems,
						cancel_btn_text: "Cancel",
						onCancel: onClose,
						submit_btn_text: "Ok"
					})
				)
			),
			dd.div({className: "clearfix"})
		);
	}
});

module.exports = dd.createClass({
	__onSubmit(data){
		let {selected_item_ids, onClearMultiItem} = this.props;
		let event = _.cloneDeep(this.props.event);

		_.each(event.EventTodo, function (todo) {
			if(!_.includes(selected_item_ids, todo.id)){
				return;
			}
			if(data["status"] === "complete"){
				todo.status = 1;
			}else if(data["status"] === "incomplete"){
				todo.status = 0;
			}
			if(_.isDate(data.statusdate)){
				todo.statusdate = data.statusdate;
			}
			let assignedto = normalizeUsername(data.assignedto);
			if(assignedto){
				todo.assignedto = assignedto;
			}
		});

		radio("save_Event").broadcast(event);
		onClearMultiItem();
	},
	__deleteItems: esUtils.wrapPreventDefault(function(){
		let {selected_item_ids, onClearMultiItem} = this.props;
		let event = _.cloneDeep(this.props.event);

		event.EventTodo = _.reject(event.EventTodo, function(todo){
			return _.includes(selected_item_ids, todo.id);
		});

		radio("save_Event").broadcast(event);
		onClearMultiItem();
	}),
	render(){
		let {event, Displaylists, selected_item_ids, onClose} = this.props;

		return Modal({
				title: "Changing " + _.size(selected_item_ids) + " Action Items",
				onClose,
				buttons: []
			},
			dd.p(null,
				"Set new values to apply to all selected items."
			),
			dd.p(null,
				"Empty fields will not change selected items."
			),
			DaForm({event, Displaylists, onClose, onSubmit: this.__onSubmit, onDeleteItems: this.__deleteItems})
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/action_list/MultiItemEditModal.js